"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
var NeutralToggleButton = (0, styles_1.styled)(ToggleButton_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        height: theme.spacing(4),
        borderColor: 'transparent',
        textTransform: 'initial',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        color: 'inherit',
        padding: theme.spacing(1),
        '&.Mui-selected': {
            backgroundColor: 'transparent',
            color: 'inherit',
            '&:hover': { backgroundColor: '#fff' },
        },
        '&:hover': { backgroundColor: '#fff' },
    });
});
exports.default = NeutralToggleButton;
